import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { HubSpotPayload, UserAPI } from 'api/user';

export const useUpdateHubspotMutation = (): UseMutationResult<
  void,
  unknown,
  HubSpotPayload
> => {
  return useMutation((payload) => UserAPI.updateHubspot(payload));
};
